
























import Vue from 'vue';
import Component from 'vue-class-component';
import dayjs from 'dayjs';

@Component
export default class TheAuthContainer extends Vue {
  // Headerに表示する文字列．環境変数から取得
  header_str = process.env.VUE_APP_HEADER_STR;

  // Loadingの表示，非表示の制御
  toggleLoading(params: { is_loading: boolean; time: number }): void {
    this.$emit('toggleLoading', params);
  }

  async mounted(): Promise<any> {
    let last_view_update = await this.$store.state.last_view_update;
    if (
      last_view_update == 0 ||
      dayjs()
        .subtract(1, 'days')
        .unix() > last_view_update
    ) {
      last_view_update = dayjs().unix();
      await this.$store.commit('setLastViewUpdate', last_view_update);
      location.reload(true);
    }
  }
}
